import { ISSOTrackingProps } from 'main/components/common/AuthModal/types'

export type IReturnState = ISSOTrackingProps

export const getReturnState = (props: ISSOTrackingProps): IReturnState => {
  return {
    source: props.source,
    segmentData: props.segmentData,
  }
}
